import { cva, VariantProps } from "class-variance-authority";
import React from "react";
import styles from "./../button.module.scss";

const linkButton = cva([styles.btn, styles.linkBtn], {
  variants: {
    buttonStyle: {
      primary: styles.primary,
      secondary: styles.secondary,
      default: styles.default,
      success: styles.success,
      danger: styles.danger,
      warning: styles.warning,
      twitter: styles.twitter,
      google: styles.google,
      facebook: styles.facebook,
      linkedin: styles.linkedin,
      xing: styles.xing,
    },
    block: {
      true: styles.block,
    },
    iconed: {
      true: styles.iconed,
    },
    fab: {
      true: styles.fab,
    },
    raised: {
      true: styles.raised,
    },
    bordered: {
      true: styles.bordered,
    },
    disabled: {
      true: styles.disabled,
    },
    size: {
      small: ["btn--sm"],
      medium: ["btn--lg"],
    },
  },
  defaultVariants: {
    buttonStyle: "primary",
    size: "medium",
  },
});

export interface LinkButtonProps
  extends React.LinkHTMLAttributes<any>,
    VariantProps<typeof linkButton> {
  /**
   * Text for the button
   *
   * @default null
   */
  children?: React.ReactNode;
  /**
   * Link target element.
   */
  target?: string;
  /**
   * Link href.
   */
  linkElement?: React.ElementType;
}

/**
 * Primary UI component for user interaction
 */
export const LinkButton = React.forwardRef(
  (
    {
      children,
      className,
      buttonStyle,
      block,
      raised = true,
      iconed = false,
      fab = false,
      bordered = false,
      disabled,
      size,
      linkElement,
      ...props
    }: LinkButtonProps,
    ref,
  ) => {
    const LinkElement = linkElement || "a";
    return (
      <LinkElement
        ref={ref as React.LegacyRef<any>}
        className={linkButton({
          buttonStyle,
          block,
          iconed,
          fab,
          raised,
          bordered,
          disabled,
          size,
          class: className,
        })}
        {...props}
      >
        {children}
      </LinkElement>
    );
  },
);
export default LinkButton;
